import { queryOptions, useMutation } from '@tanstack/react-query';

import { STANDARD_STALE_TIME, queryClient } from '$/services/fetcher';
import {
  getAdminOptions,
  upsertAdminOption,
} from '$/services/usecases/adminOptions';
import { PublicAdminOption } from '$/services/usecases/adminOptions/mapper';

export const adminOptionsQuery = (type: PublicAdminOption['type']) =>
  queryOptions({
    queryKey: ['adminOptions', type],
    queryFn: async () => {
      const { response } = await getAdminOptions(type);

      return response.payload ?? [];
    },
    staleTime: STANDARD_STALE_TIME,
  });

export const useUpsertAdminOption = (
  options: { onSuccess?: () => void } = {},
) => {
  return useMutation({
    mutationFn: upsertAdminOption,
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['adminOptions'],
      });
      await queryClient.invalidateQueries({ queryKey: ['brandCountries'] });
    },
    ...options,
  });
};
